// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3IcjY","actionsCol":"EnrolledClinics_actionsCol__PGBmJ"};